import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import EditCartItem from 'bento-ordering/cart/containers/EditCartItem';

class EditCartItemRoute extends React.Component {
  static propTypes = {
    match: PropTypes.object
  };

  render() {
    const { match } = this.props;
    return <EditCartItem id={match.params.id} />;
  }
}

export default withRouter(EditCartItemRoute);
